export const CREATE_SCOPE_OF_WORK_MUTATION = `
  mutation CreateScopeOfWork($object: scope_of_work_insert_input!) {
    insert_scope_of_work_one(object: $object) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_SCOPE_OF_WORK_MUTATION = `
  mutation UpdateScopeOfWork($id: Int!, $set: scope_of_work_set_input!) {
    update_scope_of_work_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_SCOPE_OF_WORK_MUTATION = `
  mutation DeleteScopeOfWork($id: Int!) {
    delete_scope_of_work_by_pk(id: $id) {
      id
    }
  }
`; 